export default __webpack_public_path__ + "static/2338-d80d00a0e1eac5d9ffb368d36cf5aab9.gif";